import api from './api';

export const generateParentReport = async (projectId) => {
  const response = await api.get(`/reports/project/${projectId}/parent`);
  return response.data;
};

export const generateDynamicProjectReport = async (projectId) => {
  const response = await api.get(`/reports/project/${projectId}/dynamic`);
  return response.data;
};

export const generateReport = async (reportData) => {
  // reportData can include: report_type, project_id, etc.
  const response = await api.post('/reports/generate', reportData);
  return response.data;
};

export const getProjectReport = async (projectId) => {
  const response = await api.get(`/reports/project/${projectId}`);
  return response.data;
};

export const getAllReports = async () => {
  const response = await api.get('/reports/');
  return response.data;
};
